import React, { useEffect, useState } from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { Button, Col, Row } from "antd";
import { validations } from "../../../../config/validations/validations";
import SVGIcon from "../../../../utils/SVGIcon";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { disabledSaveBtn } from "../../../../config/Global";

const FormNetworkProvider: React.FC<any> = ({
  editModalData,
  form,
  mode,
  totalData,
  handleSearchSubmit,
  handleEditModal,
  handleAddSubmit,
  handleEditSubmit,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);
  const handleSubmit = (data: any) => {
    setLoading(true);
    if (mode === "add") {
      handleAddSubmit(data);
    } else if (mode === "edit") {
      data.id = editModalData.row_id;
      handleEditSubmit(data);
    } else if (mode === "search") {
      handleSearchSubmit(data);
      setDisabledClear(false);
    }
    setLoading(false);
    form.resetFields();
  };
  const clear = () => {
    form.resetFields();
    if (mode === "search") {
      handleSearchSubmit();
      setDisabledSearch(true);
      setDisabledClear(true);
    }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };
  useEffect(() => {
    if (editModalData) {
      form.setFieldsValue({ ...editModalData });
    }
  }, [editModalData, form]);
  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"middle"}>
          <Col xs={24} md={12} xl={mode === "edit" ? 12 : 6}>
            <InputBox.Text
              name="providers"
              label="Provider Code"
              required={mode === "search" ? false : true}
              disabled={totalData > 29 && mode === "add" ? true : false}
              rules={[
                mode !== "search"
                  ? validations.required.text("Provider Code")
                  : validations.min.text(2, "Provider Code"),
                validations.max.text(10, "Provider Code"),
                validations.pattern.noSpace,
              ]}
            />
          </Col>
          <Col xs={24} md={12} xl={mode === "edit" ? 12 : 6}>
            <InputBox.Text
              name="provider_name"
              label="Provider Name"
              required={mode === "search" ? false : true}
              disabled={totalData > 29 && mode === "add" ? true : false}
              rules={[
                mode !== "search"
                  ? validations.required.text("Provider Name")
                  : validations.min.text(3, "Provider Name"),
                validations.max.text(30, "Provider Name"),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12} xl={mode === "edit" ? 12 : 6}>
            <InputBox.Text
              name="email"
              label="Email"
              required={mode === "search" ? false : true}
              tooltip="Please enter up to 5 valid email addresses, separated by commas."
              disabled={totalData > 29 && mode === "add" ? true : false}
              rules={[
                mode !== "search"
                  ? validations.required.text("Provider Email")
                  : validations.min.text(2, "Provider Email"),
                validations.pattern.multiEmail("Provider Email"),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12} xl={mode === "edit" ? 12 : 6}>
            <InputBox.Number
              name="network_identity"
              label="Network Identity"
              required={mode === "search" ? false : true}
              disabled={totalData > 29 && mode === "add" ? true : false}
              rules={[
                mode !== "search"
                  ? validations.required.text("Network Identity")
                  : validations.pattern.numericWithSecial,
                validations.pattern.numericWithSecial,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          {/* <Col
            xs={24}
            md={12}
            xl={mode === 'edit' ? 12 : 4}
          >
            <InputBox.Select
              label="Status"
              name={'status'}
              placeholder="Select Status"
              options={{
                list: CONSTANT.STAR_PROVIDER_STATUS,
                valueKey: 'id',
                textKey: 'value',
              }}
              required={mode === 'search' ? false : true}
              disabled={totalData > 29 && mode === 'add' ? true : false}
              rules={[mode !== 'search' ? validations.required.select('Status') : validations.pattern.whitespace]}
            />
          </Col> */}
          <Col xs={12} md={6} lg={6} xl={mode === "edit" ? 6 : 4}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                totalData > 29 && mode === "add"
                  ? true
                  : mode === "search"
                    ? disabledSearch
                    : false
              }
              loading={loading}
            >
              {mode === "add" ? (
                <SVGIcon icon="add" color="#fff" width={55} />
              ) : mode === "edit" ? (
                <EditOutlined />
              ) : (
                <SearchOutlined />
              )}{" "}
              {mode === "add" ? "Add" : mode === "edit" ? "Update" : "Search"}
            </Button>
          </Col>
          <Col xs={12} md={6} lg={6} xl={mode === "edit" ? 6 : 4}>
            {mode === "edit" ? (
              <Button
                type="default"
                htmlType="reset"
                onClick={() => {
                  handleEditModal();
                }}
              >
                Cancel
              </Button>
            ) : (
              <Button
                type="default"
                htmlType="reset"
                disabled={mode === "search" ? disabledClear : false}
                onClick={() => {
                  clear();
                }}
              >
                Clear
              </Button>
            )}
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormNetworkProvider;
